import "./nav-panel.scss";

const initNavPanel = () => {
  const $menuButton = document.getElementById("navbarDropdown");

  $menuButton.addEventListener("click", event => {
    event.preventDefault();

    const $dropdownMenu = event.target.nextElementSibling;
    const isExpanded = $dropdownMenu.classList.contains("show");

    // Toggle the show class
    $dropdownMenu.classList.toggle("show");

    // Update aria-expanded
    event.target.setAttribute("aria-expanded", !isExpanded);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initNavPanel();
});
